<div class="container-fluid px-4">
  <div class="row align-items-center">
    <div class="col user-nav">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <div class="me-3">
            <h6 class="mb-0 text-white fs-6 fw-normal">{{ userName }}</h6>
<!--            <p class="mb-0 text-white small">Инспектор (МПТП Достук)</p>-->
          </div>
          <div class="dropdown">
            <button
              title="user"
              class="btn btn-link p-0 dropdown-toggle"
              type="button"
              id="userDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <fa-icon [icon]="faCircleUser" class="fa-2x text-user-icon"></fa-icon>
            </button>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
              @if (isLoggedIn) {
                <li><a class="dropdown-item" (click)="logout()">Выйти</a></li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
